import { FaBalanceScale, FaHandshake, FaUserTie } from "react-icons/fa"


export const features = [
    {
      icon: <FaBalanceScale className="text-5xl text-[var(--dark-red)] mb-4" />,
      title: "Justicia Accesible",
      description: "Facilitamos el acceso a servicios legales de calidad para todos.",
    },
    {
      icon: <FaHandshake className="text-5xl text-[var(--dark-red)] mb-4" />,
      title: "Conexiones Confiables",
      description: "Unimos a clientes con los mejores bufetes de abogados verificados.",
    },
    {
      icon: <FaUserTie className="text-5xl text-[var(--dark-red)] mb-4" />,
      title: "Profesionalismo",
      description: "Garantizamos servicios legales de la más alta calidad y ética.",
    },
  ];

